import Script from 'next/script';
import { useConsentHandler } from '@/lib/consent';
import { disableOpenAIAds, enableOpenAIAds } from '@/lib/analytics/openaiAds/client';
import { useOpenAIAdsEnabled } from '@/lib/analytics/openaiAds/useOpenAIAdsEnabled';
import { NEXT_PUBLIC_OPENAI_ADS_LOGGING_ENABLED, NEXT_PUBLIC_OPENAI_ADS_PIXEL_ID } from '@/lib/env';

const OpenAIAdsScript = () => {
  useConsentHandler('openaiAds', ({ allowed }) => {
    if (allowed) {
      enableOpenAIAds();
      return;
    }

    disableOpenAIAds();
  });

  const openAIAdsEnabled = useOpenAIAdsEnabled();
  if (!openAIAdsEnabled) {
    return null;
  }

  return (
    <Script id="openai-ads-pixel" strategy="afterInteractive">
      {`
        !function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments);};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f);}(window,document,'script','https://bzrcdn.openai.com/sdk/oaiq.min.js');
        oaiq('init', {
          pixelId: '${NEXT_PUBLIC_OPENAI_ADS_PIXEL_ID ?? ''}',
          debug: ${NEXT_PUBLIC_OPENAI_ADS_LOGGING_ENABLED},
        });
      `}
    </Script>
  );
};

export default OpenAIAdsScript;
